import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.takecare.heading',
		defaultMessage: 'Take care of yourself first',
		description: 'Calm Schools quote text',
	},
	blurb1: {
		id: 'schools.takecare.blurb1',
		defaultMessage:
			'Just as we put on our oxygen mask first, we can best support the health and happiness of others by taking care of ourselves first.',
		description: 'Calm Schools quote text',
	},
	blurb2: {
		id: 'schools.takecare.blurb2',
		defaultMessage:
			'Meditate regulary to reduce stress, prevent burnout and improve your relationships with students, parents and colleagues.',
		description: 'Calm Schools quote text',
	},
	blurb3: {
		id: 'schools.takecare.blurb3',
		defaultMessage:
			'Listen to Calm Music and Sleep Stories at the end of a busy day to help you wind down and fall asleep with ease.',
		description: 'Calm Schools quote text',
	},
	button: {
		id: 'schools.takecare.button',
		defaultMessage: 'Start today',
		description: 'Calm Schools quote text',
	},
});
